import FollowupSettingsTab from './followup-settings';

export default FollowupSettingsTab;
